<template>
  <div
    class="answer-wrapper"
    @mouseleave="showPopup = false"
    @mouseenter="showPopup = true"
  >
    <!-- <div class="answer-text" v-if="checkEmpty()">
          <span
            v-if="selectedAddAnswer === null"
            @click="selectedAddAnswer = questionId"
            >Add</span
          >
          <md-progress-spinner
            class="spinner-answer"
            v-if="showSpinner"
            :md-diameter="19"
            :md-stroke="3"
            md-mode="indeterminate"
          ></md-progress-spinner>

          <btn-bar
            v-if="selectedAddAnswer === questionId"
            @confirm="setAnswer(questionId, depositId, 1)"
            @reject="setAnswer(questionId, depositId, 0)"
          ></btn-bar>
        </div>

        <span v-if="!checkEmpty()">
          <span
            class="answer-text"
            @click="updateAnswer(matchedAnswer().id, 0)"
            v-if="matchedAnswer().answer_confirm !== 0"
          >
            <img width="21" src="/img/icons/correct.svg"/></span
          ><span
            class="answer-text"
            v-else
            @click="updateAnswer(matchedAnswer().id, 1)"
          >
            <img width="21" src="/img/icons/close.svg"
          /></span>
          <md-progress-spinner
            class="spinner-answer"
            v-if="showSpinner"
            :md-diameter="19"
            :md-stroke="3"
            md-mode="indeterminate"
          ></md-progress-spinner
        ></span>  v-if="selectedAddAnswer === questionId"-->

    <div class="floating-wrapper-answers">
      <div class="dropdown ">
        <div class="answer">
          <span class="answer-text" v-if="matchedAnswer() !== undefined">
            <span
              class="answer-text"
              @click="updateAnswer(matchedAnswer().id, 0)"
              v-if="matchedAnswer().answer_confirm !== 0"
            >
              <img width="21" src="/img/icons/correct.svg"/></span
            ><span
              class="answer-text"
              v-else
              @click="updateAnswer(matchedAnswer().id, 1)"
            >
              <img width="21" src="/img/icons/close.svg"
            /></span>

            <!--  {{ matchedAnswer().answer_confirm  }}--> </span
          ><span v-else data-toggle="dropdown">Add</span>

          <div class="dropdown-menu  answers-dropdown-menu">
            <btn-bar
              @confirm="setAnswer(questionId, depositId, 1)"
              @reject="setAnswer(questionId, depositId, 0)"
            ></btn-bar>
          </div>
          <div class="spinner-answer">
            <loader
              class="spinner-bottom-ms"
              v-if="showSpinner"
              :size="'3px'"
            ></loader>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--   <div class="floating-wrapper-answers">
      <div class="dropdown ">
        <div class="answer" data-toggle="dropdown">
        {{ answers[0].answer.answer | truncate(8) }}-->

  <!--          <span class="answer-text" >
              {{ matchedAnswer()  }}</span
            >
          </div>-->

  <!--        <ul class="dropdown-menu  answers-dropdown-menu">
            <input
              class="input-standard"
              type="search"
              placeholder="Search answer"
              v-model="answerQuery"
              @keyup="answerResults = filterList(answerQuery)"
            />
            <div class="dropdown-divider"></div>
            <div v-if="answerResults.length > 0 && answerQuery.length > 0">
              <li
                @click="
                  matchedAnswer() !== undefined
                    ? updateAnswer(matchedAnswer().id, answer.id, client.id)
                    : saveAnswer(answer.id, client.id)
                "
                class="answer-menu-item"
                v-for="answer in answerResults"
                :key="answer.id"
              >
                {{ answer.answer }}
              </li>
            </div>
            <div v-if="answerResults.length === 0 || answerQuery.length === 0">
              <li
                @click="
                  matchedAnswer() !== undefined
                    ? updateAnswer(matchedAnswer().id, answer.id, client.id)
                    : saveAnswer(answer.id, client.id)
                "
                class="answer-menu-item"
                v-for="answer in dictionaries.general.client_questions[
                  questionId - 1
                ].answers"
                :key="answer.id"
              >
                {{ answer.answer }}
              </li>
            </div>
          </ul>
        </div>
      </div>-->

  <!--    <div v-if="matchedLog().length === 0 && showPopup" class="answer-table">
        <div class="table-responsive">
          <table class="table">
            <tbody>
              <tr>
                <td>
                  <strong>{{
                    dictionaries.general.client_questions[questionId - 1].question
                  }}</strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>-->

  <!--    <div v-if="matchedLog().length > 0 && showPopup" class="answer-table">
        <div class="table-responsive">
          <table class="table">
            <tbody>
              <tr v-for="(item, idx) in matchedLog()" :key="idx">
                &lt;!&ndash;              <td>{{ formatDateTable(matchedAnswer().updated_at) }}</td>
                <td>{{ matchedAnswer().updated_at | shortTime }}</td>
                 <td class="td-answer">{{ matchedAnswer().answer.answer }}</td>
                <td>{{ matchedAnswer().user.full_name }}</td>&ndash;&gt;
                <td>{{ formatDateTable(item.updated_at) }}</td>
                <td>{{ item.updated_at | shortTime }}</td>
                <td>
                  {{
                    dictionaries.general.client_questions[questionId - 1].question
                  }}
                </td>
                <td class="td-answer">{{ item.answer.answer }}</td>
                <td>{{ item.user.full_name }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>-->
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import BtnBar from "../misc/ConfirmIconButtons.component";

import apiClientCreator from "../../../../../../helpers/api/request";
import Loader from "../../../../../../main/misc.main/loader/Loader";

export default {
  name: "ClientAnswer.component",
  components: {
    Loader,
    BtnBar
  },
  props: {
    client: {
      ///answer
      type: Object,
      required: true
    },
    questionId: {
      type: Number,
      required: true
    },
    depositId: {
      type: Number,
      required: true
    },
    sendUpdated: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {
    ...mapState("clients", ["dictionaries"])
  },
  data() {
    return {
      showPopup: false,
      matchedAns: {},
      showDropDown: false,
      answerQuery: "",
      answerResults: [],
      answeringBusy: false,
      showSpinner: false,
      selectedAddAnswer: null,
      selectedUpdateAnswer: null
    };
  },
  created() {
    //   this.matchedAnswer()
    // this.matchedLog();
  },

  methods: {
    formatDateTable(date) {
      return moment(String(date)).format("DD/MM/YY ");
    },
    checkEmpty() {
      //  console.log(this.questionId);
      /*onsole.log(this.client.find(
                        answer =>  answer.deposit_id ===  this.depositId).answer_confirm)*/

      let tt = null;
      tt = this.client.find(answer => answer.question_id === this.questionId);

      //  console.log("found: ", tt);
      if (tt === null) {
        //   console.log(true);
        return true;
      } else {
        //  console.log(false);
        return false;
      }
    },

    matchedAnswer() {
      /*      console.log( this.client.find(
                        answer =>  answer.deposit_id ===  this.depositId && answer.question_id ===  this.questionId
                ).answer_confirm)*/
      return this.client.find(
        answer =>
          answer.deposit_id === this.depositId &&
          answer.question_id === this.questionId
      );
    },
    /*    matchedLog() {
              return this.client.answers_log.filter(
                answer => answer.question_id === this.questionId
              );
            },*/
    async setAnswer(questionId, depositId, answer) {
      this.showSpinner = true;
      this.answeringBusy = true;
      let vm = this;
      let apiClient = apiClientCreator(
        `client/support/deposit/answer/${depositId}`
      );
      await apiClient.post("", {
        question_id: questionId,
        answer_confirm: answer
      });
      this.$emit("updated");
      this.showSpinner = false;
      this.selectedAddAnswer = null;
    },

    async updateAnswer(answerId, answer) {
      this.showSpinner = true;
      this.answeringBusy = true;
      // let vm = this;
      let apiClient = apiClientCreator(
        `client/support/deposit/answer/${answerId}`
      );
      await apiClient.put("", { answer_confirm: answer });
      this.$emit("updated");
      this.showSpinner = false;
    }
  }
};
</script>

<style scoped>
.answer {
  cursor: pointer;
}

/*.answer-wrapper {
      display: inline;
      position: relative;
      text-align: center;
    }*/
.answer-wrapper {
  text-align: center;
}

.floating-wrapper-answers {
  position: relative;
}

.answer-table {
  position: absolute;
  bottom: 0px;
  right: 0px;
  z-index: 10001;
  width: max-content;
  background-color: #fff;
  border: solid 1px #90a4ae;
  border-radius: 5px;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}

.table-responsive {
  margin-bottom: -20px;
  border-radius: 5px;
}

.td-answer {
  font-weight: 600;
}

.answers-dropdown {
  width: max-content;
}

.answers-dropdown-menu {
  border: solid 1px #90a4ae;
  border-radius: 0;
  left: 0;
  position: absolute;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}

.dropdown-menu {
  top: -222px;
  padding: 5px;
  height: auto;
  position: absolute;
  max-height: 500px;
  min-width: -webkit-max-content;
  background-color: white;
  min-width: -moz-max-content;
  min-width: max-content;
  overflow-x: hidden;
  text-align: left;
  left: -60px;
}

.answer-menu-item {
  margin: 5px;
  font-size: 9pt;
  font-family: Montserrat;
}

.answer-menu-item:hover {
  background: #e0e0e0;
  cursor: pointer;
}

.answer-text {
  cursor: pointer;
}

.input-standard {
  width: 100%;
  position: relative;
  display: inline-block;
  padding: 4px 4px 4px 10px;
  border-radius: 5px;
  border-style: solid;
  border-color: #90a4ae;
  height: 30px;
  border-width: thin;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  font-size: 8pt;
  box-sizing: border-box;
}

.dropdown-divider {
  height: 1px;
  margin: 9px 0;
  overflow: hidden;
  background-color: #e5e5e5;
}

.spinner-answer {
  float: right;
  margin-top: 3px;
}
</style>
